import { render } from "./TextareaComponent.vue?vue&type=template&id=3386e58b&ts=true"
import script from "./TextareaComponent.vue?vue&type=script&lang=ts"
export * from "./TextareaComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__